import { register } from "@shopify/theme-sections";

register("footer", {

  // init scroll event w/ debounce
  getVerticalScrollOffset() {
    document.addEventListener('scroll', () => {
      let timerId;

      clearTimeout(timerId);

      timerId = setTimeout(() => {
        if (window.pageYOffset > 515) {
          document.querySelector(".footer__to-top").style.display = "flex";
        }
        else {
          document.querySelector(".footer__to-top").style.display = "none";
        }
      }, 750);
    })
  },

  scrollToTop() {
    function scrollToSmoothly(pos, time) {
      let currentPos = window.pageYOffset;
      let start = null;
      if (time == null) time = 500;
      (pos = +pos), (time = +time);
      window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        let progress = currentTime - start;
        if (currentPos < pos) {
          window.scrollTo(
            0,
            ((pos - currentPos) * progress) / time + currentPos
          );
        } else {
          window.scrollTo(
            0,
            currentPos - ((currentPos - pos) * progress) / time
          );
        }
        if (progress < time) {
          window.requestAnimationFrame(step);
        } else {
          window.scrollTo(0, pos);
        }
      });
    }

    document
      .querySelector(".footer__to-top")
      .addEventListener("click", function (e) {
        scrollToSmoothly(0, 1000);
      });
  },

  publicMethod: function () {
    // Custom public section method
  },

  _privateMethod: function () {
    // Custom private section method
  },

  // Shortcut function called when a section is loaded via 'sections.load()' or by the Theme Editor 'shopify:section:load' event.
  onLoad: function () {
    this.scrollToTop();
    this.getVerticalScrollOffset();
  },

  // Shortcut function called when a section unloaded by the Theme Editor 'shopify:section:unload' event.
  onUnload: function () {
    // Do something when a section instance is unloaded
  },

  // Shortcut function called when a section is selected by the Theme Editor 'shopify:section:select' event.
  onSelect: function () {
    // Do something when a section instance is selected
  },

  // Shortcut function called when a section is deselected by the Theme Editor 'shopify:section:deselect' event.
  onDeselect: function () {
    // Do something when a section instance is deselected
  },

  // Shortcut function called when a section block is selected by the Theme Editor 'shopify:block:select' event.
  onBlockSelect: function () {
    // Do something when a section block is selected
  },

  // Shortcut function called when a section block is deselected by the Theme Editor 'shopify:block:deselect' event.
  onBlockDeselect: function () {
    // Do something when a section block is deselected
  },
});
